import React from 'react';
import { RowSkeleton } from './row-skeleton';
export var SearchSkeletons = function SearchSkeletons() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RowSkeleton, null), /*#__PURE__*/React.createElement(RowSkeleton, null), /*#__PURE__*/React.createElement(RowSkeleton, null), /*#__PURE__*/React.createElement(RowSkeleton, null), /*#__PURE__*/React.createElement(RowSkeleton, null));
};